export var carAttendanceRateReport = {
  name: "车辆出勤率报表",
  path: "/car-attendance-rate-report",
  hidden: false,
  redirect: "noredirect",
  component: "Layout",
  elemCode: "10",
  sort: 9,
  alwaysShow: true,
  meta: {
    title: "车辆出勤率报表",
    icon: "external-link-outline",
    noCache: false
  },
  children: [{
    name: "CarAttendanceRateReport",
    path: "/car-attendance-rate-report/index",
    hidden: false,
    component: "carAttendanceRateReport/index",
    elemCode: "11",
    meta: {
      title: "车辆出勤率报表",
      noCache: true
    }
  }]
};